<div class="filter-toolbar">
	<div class="btn-group btn-group-sm" role="group">
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('all')"
			title="Alle Punkte anzeigen">
			Alle
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'map' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('map')"
			title="Nur Punkte im Kartenausschnitt">
			Karte
			<span *ngIf="mapFilterStale && listFilterMode === 'map'" class="stale-indicator">&#x21bb;</span>
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'selection' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('selection')"
			title="Nur ausgewählte Punkte">
			Auswahl
		</button>
	</div>
	<div ngbDropdown class="mt-1 filter-dropdown" *ngIf="aus.canI('use', 'filter')">
		<div class="btn-group btn-group-sm w-100">
			<button type="button" class="btn filter-toggle"
					ngbDropdownToggle
					[ngClass]="currentFilterName ? 'active-filter' : 'btn-outline-secondary'"
					[title]="currentFilterName || 'Filter wählen oder erstellen'">
				<i class="bi" [ngClass]="currentFilterName ? 'bi-funnel-fill' : 'bi-funnel'"></i>
				<span class="filter-name">{{ currentFilterName || 'Filter' }}</span>
			</button>
			<button *ngIf="currentFilterName" type="button" class="btn filter-clear"
					(click)="clearFilter()" title="Filter entfernen">
				<i class="bi bi-x-lg"></i>
			</button>
		</div>
		<div ngbDropdownMenu class="w-100 filter-menu">
			<h6 class="dropdown-header" *ngIf="filterNames.length > 0">Gespeicherte Filter</h6>
			<button ngbDropdownItem class="filter-item" *ngFor="let name of filterNames" (click)="applyQuickFilter(name)"
				[class.active]="currentFilterName === name" [title]="name">
				{{ name }}
			</button>
			<div class="dropdown-divider" *ngIf="filterNames.length > 0"></div>
			<button ngbDropdownItem class="filter-item" *ngIf="showProjectPointsFilter && pps.totalCount() > 0" (click)="applyProjectPointsFilter()"
				[class.active]="currentFilterName === 'Projektpunkte'">
				Alle Projektpunkte ({{ pps.totalCount() }})
			</button>
			<button ngbDropdownItem (click)="clearFilter()">
				Kein Filter
			</button>
			<div class="dropdown-divider"></div>
			<button ngbDropdownItem (click)="openFilterEditor()">
				<i class="bi bi-plus-lg"></i> Filter erstellen / ändern
			</button>
		</div>
	</div>
	<div class="input-group input-group-sm mt-1">
		<input type="text" class="form-control" placeholder="Nr, Amt, Revier..."
			[(ngModel)]="searchText" (ngModelChange)="onSearchTextChange($event)"
			[class.search-active]="searchText"
			[title]="suchHinweis">
		<button *ngIf="searchText" class="btn btn-outline-secondary" type="button" (click)="clearSearch()" title="Suche löschen">x</button>
	</div>
	<!-- Auswahl-Aktionen -->
	<div class="btn-group btn-group-sm mt-1 w-100" role="group">
		<button type="button" class="btn btn-outline-success"
			[disabled]="!bps.length"
			(click)="addVisibleToSelection()"
			title="Sichtbare zur Auswahl hinzufügen">
			<i class="bi bi-plus-lg"></i>
		</button>
		<button type="button" class="btn btn-outline-danger"
			[disabled]="selectionService.count() === 0"
			(click)="removeVisibleFromSelection()"
			title="Sichtbare aus Auswahl entfernen">
			<i class="bi bi-dash-lg"></i>
		</button>
		<button type="button" class="btn btn-outline-secondary"
			[disabled]="selectionService.count() === 0"
			(click)="clearSelection()"
			title="Auswahl aufheben">
			<i class="bi bi-x-circle"></i>
		</button>
		<!-- Einstellungen -->
		<button type="button" class="btn btn-outline-secondary"
			[class.active]="onlyWithProtocol || onlyProjectPoints || sortToTop !== 'none'"
			(click)="openSettings()"
			title="Listeneinstellungen">
			<i class="bi bi-gear"></i>
		</button>
	</div>
</div>
<div class="leftmenu-container">
	<div class="leftmenu">
		<!-- Hinweis und Buttons wenn mehr Punkte vorhanden als angezeigt -->
		<div *ngIf="hasMoreItems" class="list-limit-info">
			<span>{{ visibleBps.length }} von {{ totalVisibleCount }} Punkten</span>
			<span class="load-more-buttons">
				<button class="btn btn-link btn-sm" (click)="loadMore()">+{{ totalVisibleCount - visibleBps.length > 500 ? 500 : totalVisibleCount - visibleBps.length }}</button>
				<button class="btn btn-link btn-sm" (click)="loadAll()">Alle</button>
			</span>
		</div>
		<a *ngFor="let item of visibleBps; trackBy: trackByBpId" [id]="'id-'+item.bp._id" class="dropdown-item list-entry" (click)="select($event, item.bp)"
			[ngClass]="{
				'active': activeId && activeId === item.bp._id,
				'list-item-selected': selectionService.isSelected(item.bp._id)
			}">
			<!-- Punkte mit Protokoll -->
			<ng-container *ngIf="istPunktartMitProtokoll(item.bp.type)">
				<div class="list-entry-main">
					<img *ngIf="!istPunktartOhneSymbol(item.bp.type)" [src]="getSvgUrl(item.bp)" class="symbol-icon" alt="">
					<span *ngIf="istPunktartOhneSymbol(item.bp.type)" class="symbol-label" title="Punktart ohne Symbol" [style.color]="punktartOhneSymbolColor(item.bp.type)">[{{ punktartOhneSymbolLabel(item.bp.type) }}]</span>
					<span class="bp-nummer" *ngIf="item.bp.header?.nummer">{{ item.bp.header.nummer }}</span>
					<span class="list-entry-actions">
						<button type="button" class="btn-protokoll" (click)="openProtokoll($event, item.bp)" title="Protokoll öffnen">
							<i class="bi bi-file-text"></i>
							<span class="comment-indicator" [ngClass]="getCommentClass(item.bp)"></span>
						</button>
						<span class="status-dot {{ getStatusBadge(item.bp)?.bgClass }}"
							[title]="'Status: ' + (getStatusBadge(item.bp)?.label || 'Bestandsdaten')"></span>
					</span>
				</div>
				<div class="list-entry-sub">{{ (getKartierer(item.bp) || 'kein Kartierer') | maskForGuest }}</div>
			</ng-container>
			<!-- Punkte ohne Protokoll (Kurzprotokoll) -->
			<ng-container *ngIf="!istPunktartMitProtokoll(item.bp.type)">
				<div class="list-entry-main">
					<img *ngIf="!istPunktartOhneSymbol(item.bp.type)" [src]="getSvgUrl(item.bp)" class="symbol-icon" alt="">
					<span *ngIf="istPunktartOhneSymbol(item.bp.type)" class="symbol-label" title="Punktart ohne Symbol" [style.color]="punktartOhneSymbolColor(item.bp.type)">[{{ punktartOhneSymbolLabel(item.bp.type) }}]</span>
					<span class="list-entry-actions">
						<button type="button" class="btn-protokoll" (click)="openProtokoll($event, item.bp)" title="Kurzprotokoll öffnen">
							<i class="bi bi-file-text"></i>
							<span class="comment-indicator" [ngClass]="getCommentClass(item.bp)"></span>
						</button>
						<span class="status-dot {{ getStatusBadge(item.bp)?.bgClass }}"
							[title]="'Status: ' + (getStatusBadge(item.bp)?.label || 'Bestandsdaten')"></span>
					</span>
				</div>
				<div class="list-entry-sub">
					<span *ngIf="getKurzinfoRed(item.bp) || getKurzinfoGreen(item.bp)">
						<span class="kurzinfo-red" *ngIf="getKurzinfoRed(item.bp)">{{ getKurzinfoRed(item.bp) }}</span>
						<span class="kurzinfo-green" *ngIf="getKurzinfoGreen(item.bp)">{{ getKurzinfoGreen(item.bp) }}</span>
					</span>
					<span class="kartierer-info">{{ (getKartierer(item.bp) || 'kein Kartierer') | maskForGuest }}</span>
				</div>
			</ng-container>
		</a>
	</div>
</div>
<!-- Statistik-Zeile unten -->
<div class="stats-bar">
	<span title="Gesamtanzahl">G:{{ bps.length }}</span>
	<span class="stat-map" title="Im Kartenausschnitt">K:{{ getMapCount() }}</span>
	<span class="stat-selected" title="Ausgewählt">A:{{ selectionService.count() }}</span>
	<span class="stat-info" (click)="showStatsHelp()" title="Hilfe"><i class="bi bi-info-circle"></i></span>
</div>

<!-- Statistik-Hilfe Modal -->
<ng-template #statsHelpModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Statistik-Legende</h5>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<table class="table table-sm">
			<tbody>
				<tr>
					<td class="text-muted"><strong>G:</strong></td>
					<td>Gesamtanzahl aller Punkte in der Datenbank</td>
				</tr>
				<tr>
					<td style="color: #98d8a0"><strong>K:</strong></td>
					<td>Anzahl Punkte im aktuellen Kartenausschnitt</td>
				</tr>
				<tr>
					<td style="color: #6dd5ed"><strong>A:</strong></td>
					<td>Anzahl ausgewählter Punkte</td>
				</tr>
			</tbody>
		</table>
		<hr>
		<p class="mb-2 fw-semibold">Status-Punkt (farbige Kugel je Zeile)</p>
		<table class="table table-sm mb-0">
			<tbody>
				<tr *ngFor="let badge of statusLegend">
					<td class="text-center" style="width: 1.5rem">
						<span class="status-dot {{ badge.bgClass }}"></span>
					</td>
					<td>{{ badge.label }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-template>

<!-- Einstellungen Modal -->
<ng-template #settingsModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Listeneinstellungen</h5>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<div class="form-check mb-3">
			<input class="form-check-input" type="checkbox" id="onlyWithProtocol"
				[(ngModel)]="onlyWithProtocol" (ngModelChange)="onSettingsChange()">
			<label class="form-check-label" for="onlyWithProtocol">
				Nur Punkte mit Protokoll anzeigen
			</label>
		</div>
		<div class="form-check mb-3">
			<input class="form-check-input" type="checkbox" id="onlyShowSelected"
				[(ngModel)]="onlyShowSelected" (ngModelChange)="onSettingsChange()">
			<label class="form-check-label" for="onlyShowSelected">
				Nur ausgewählte anzeigen
			</label>
		</div>
		<div class="form-check mb-1">
			<input class="form-check-input" type="checkbox" id="onlyProjectPoints"
				[(ngModel)]="onlyProjectPoints" (ngModelChange)="onSettingsChange()">
			<label class="form-check-label" for="onlyProjectPoints">
				Nur Punkte des Projekts in der Karte anzeigen
			</label>
		</div>
		<div class="form-text mb-3">Betrifft nur die Karte – die Liste bleibt unverändert.</div>
		<hr>
		<div class="mb-3">
			<label class="form-label">Nach oben sortieren</label>
			<select class="form-select form-select-sm" [(ngModel)]="sortToTop" (ngModelChange)="onSettingsChange()">
				<option value="none">– Keine –</option>
				<option value="selected">Ausgewählte Punkte</option>
				<option value="assigned">Dem Projekt zugeordnete Punkte</option>
				<option value="filtered">Gefilterte Punkte</option>
			</select>
		</div>
		<hr>
		<div class="mb-3">
			<label class="form-label">Sortierung</label>
			<select class="form-select form-select-sm" [(ngModel)]="sortOrder" (ngModelChange)="onSettingsChange()">
				<option value="type">Nach Typ</option>
				<option value="nummer">Nach Nummer</option>
				<option value="kartierer">Nach Bearbeiter</option>
				<option value="datum">Nach Datum</option>
			</select>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary btn-sm" (click)="modal.close()">Schließen</button>
	</div>
</ng-template>
